import { FC } from 'react';

import { Input, Select, Typography } from 'antd';

import { IProfileItem } from 'entities/User';
import { CopyButton } from 'shared/ui';

interface IProfileItemProps {
	item: IProfileItem;
	isDisabled?: boolean;
}

export const ProfileItem: FC<IProfileItemProps> = ({ item, isDisabled }) => {
	const { action, items, title, type, value } = item;
	return (
		<>
			<dt>
				<Typography.Text>{title}</Typography.Text>
			</dt>
			<dd>
				{type === 'text' && <Typography.Text>{value}</Typography.Text>}
				{type === 'input' && (
					<Input
						size="middle"
						value={value}
						suffix={
							<CopyButton
								text={String(value)}
								size="small"
								variant="text"
								style={{ border: 'none', boxShadow: 'none' }}
							/>
						}
					/>
				)}
				{type === 'select' && (
					<Select
						style={{ width: '100%' }}
						value={value}
						options={items}
						disabled={isDisabled}
						onChange={(val) => !!action && action(item.key, String(val))}
						size="large"
					/>
				)}
			</dd>
		</>
	);
};
